import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Image, Row } from 'react-bootstrap';
import InstituteLogo from '../../../assets/images/institute-logo.png';
import { HDivider } from 'components/CommonWidgets';
import { useDispatch, useSelector } from 'react-redux';
import { AiFillPieChart } from 'react-icons/ai';
import { BsFillInfoSquareFill } from 'react-icons/bs';
import { IoIosPaper } from 'react-icons/io';
import { FaUsers } from 'react-icons/fa';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import useScreen from 'hooks/useScreen';
import { toggleRightSidebar } from 'redux/global.slice';
import { RiShoppingCartFill } from 'react-icons/ri';

const Holder = styled.div`
	background-color: white;
	padding: 0.5rem 1rem;
	height: 96vh;
	position: ${(props) => props.expanded ? 'absolute' : 'relative'};	
	top: ${(props) => props.expanded ? '1rem' : '-5rem'};
	right: 0;
	transform: ${(props) => {
		if (props.expanded) {			
			return 'translateX(-1rem)';
		}		
		return props.invisible ? 'translateX(60rem)' : 'translateX(0px)'
	}};	
	margin-right: 0.5rem;
	border-radius: 3rem;
	direction: rtl;
	z-index: 333;
	transition-property: ${(props) => props.expanded ? 'transform' : 'none'};
	transition-duration: 400ms;
	transition-timing-function: ease-out;

	& > div {
		display: flex;
		align-items: center;
		cursor: pointer;

		&.user-section {
			position: relative;
		}
	}
`;

const Label = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const SidebarMenu = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: center;
    padding: 0.5rem;	
`;

const SidebarItem = styled.div`
	width: 100%;
	display: flex;
	justify-content: start;
	margin: 0.2rem 0;
	padding: 0.5rem;

	border-radius: ${(props) => props.selected ? '28px' : '0'};
	background-color: ${(props) => props.selected ? '#1878EE' : 'white'};
	color: ${(props) => props.selected ? 'white' : 'black'};
`;

const RightSidebar = () => {
	const { isSidebarExpanded } = useSelector((store) => store.global);
	const dispatch = useDispatch();

	const location = useLocation();
	const navigate = useNavigate();
	const { lessThan1200, lessThan900 } = useScreen();

	const isSelected = (link) => location.pathname === link;

	const getIconColor = (link) => isSelected(link) ? 'white' : 'black';

	const onDashboardTap = () => {
		navigate('/admin/dashboard');
		dispatch(toggleRightSidebar(false));
	};
	const onInformationTap = () => {
		navigate('/admin/information');
		dispatch(toggleRightSidebar(false));
	};
	const onReportingTap = () => {
		navigate('/admin/reporting');
		dispatch(toggleRightSidebar(false));
	};
	const onUsersTap = () => {
		navigate('/admin/users');
		dispatch(toggleRightSidebar(false));
	};
	const onOperationsTap = () => {
		navigate('/admin/operations');
		dispatch(toggleRightSidebar(false));
	};

	return (
		<Holder expanded={lessThan900 && isSidebarExpanded} invisible={lessThan900 && !isSidebarExpanded}>
			<div className="d-flex justify-content-center">
				<Image width={82} height={82} src={InstituteLogo} />
			</div>
			<SidebarMenu className='mt-1'>
				<SidebarItem selected={isSelected('/admin/dashboard')} onClick={onDashboardTap}>
					<AiFillPieChart size={20} color={getIconColor('/dashboard')} className="ms-3" />
					<Label>داشبورد مدیریتی</Label>
				</SidebarItem>
				<SidebarItem selected={isSelected('/admin/operations')} onClick={onOperationsTap}>
					<RiShoppingCartFill size={20} color={getIconColor('/operations')} className="ms-3" />
					<Label>عملیات انبارداری</Label>
				</SidebarItem>
				{/* {!isSelected('/users') && <HDivider className="w-100" />} */}
				{/* {!isSelected('/dashboard') && <HDivider className="w-100" />} */}
				<SidebarItem selected={isSelected('/admin/information')} onClick={onInformationTap}>
					<BsFillInfoSquareFill size={20} color={getIconColor('/information')} className="ms-3" />
					<Label>اطلاعات پایه</Label>
				</SidebarItem>
				{/* <HDivider className="w-100" /> */}
				<SidebarItem selected={isSelected('/admin/reporting')} onClick={onReportingTap}>
					<IoIosPaper size={20} color={getIconColor('/reporting')} className="ms-3" />
					<Label>گزارش گیری</Label>
				</SidebarItem>
				{/* {!isSelected('/reporting') && <HDivider className="w-100" />} */}
				<SidebarItem selected={isSelected('/admin/users')} onClick={onUsersTap}>
					<FaUsers size={20} color={getIconColor('/users')} className="ms-3" />
					<Label>مدیریت کاربران</Label>
				</SidebarItem>
				{/* {!isSelected('/users') && <HDivider className="w-100" />} */}				
			</SidebarMenu>
		</Holder>
	);
};

export default RightSidebar;
